import { NAVER_REDIRECT_URI, NAVER_REST_API_KEY } from '../../../../constants/url';

import naverImg from '../../../../images/common/btn_naver.svg';

const NaverLogin = () => {
  const handleNaverLogin = () => {
    // const STATE = crypto.randomUUID();
    const redirectUri = encodeURIComponent(NAVER_REDIRECT_URI);
    const loginUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_REST_API_KEY}&redirect_uri=${redirectUri}`;

    // sessionStorage.setItem('naver_state', STATE);

    window.location.href = loginUrl;
  };

  return (
    <div className="naver-login-container">
      <button data-login="naver" title="네이버 아이디로 로그인하기" onClick={handleNaverLogin}>
        <img src={naverImg} alt="네이버 로그인" />
      </button>
    </div>
  );
};

export default NaverLogin;